import styled from '@emotion/styled';
// @ts-expect-error There is probably a better way of dealing with this
export const Box = styled('div', {
    shouldForwardProp: (prop) => !['styles', 'as'].includes(prop),
})((props) => props.styles);
